export default "__VITE_ASSET__BHzjk0oF__"